import {PartnerPageShell} from "components/commons";
import {WealthyEnv} from "helpers";
import dynamic from "next/dynamic";
import React from "react";

const LumpsumPageContent = dynamic(() => import("components/Calculators/Lumpsum"));

const LumpsumPage = ({seoData}) => (
  <PartnerPageShell seoData={seoData}>
    <LumpsumPageContent />
  </PartnerPageShell>
);

export async function getStaticProps() {
  const seoData = {
    title: "Lumpsum Calculator for MFDs | Lump Sum Mutual Fund Calculator | Wealthy",
    description:
      "Use Wealthy's Lumpsum Calculator to estimate one-time mutual fund investment returns, compare scenarios and help clients plan financial goals with confidence.",
    keywords:
      "lumpsum calculator, lump sum calculator, lump sum mutual fund calculator, lump sum return calculator",
    canonicalUrl: `${WealthyEnv.URL}/partner/calculators/lumpsum`,
    ogImage: `${WealthyEnv.HOMEPAGE_CDN_URL}/wealthy-og-image.jpg`,
    schema: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Home",
              item: `${WealthyEnv.URL}`
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "Calculators",
              item: `${WealthyEnv.URL}/partner/calculators`
            },
            {
              "@type": "ListItem",
              position: 3,
              name: "Lumpsum Calculator",
              item: `${WealthyEnv.URL}/partner/calculators/lumpsum`
            }
          ]
        },
        {
          "@type": "FAQPage",
          mainEntity: [
            {
              "@type": "Question",
              name: "What is a Lumpsum Calculator?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "A lumpsum calculator is an online planning tool that estimates the future value of a one-time mutual fund investment. By entering the investment amount, expected annual return and investment tenure, distributors can help clients understand how their investment could grow over time."
              }
            },
            {
              "@type": "Question",
              name: "How does a Lumpsum Calculator work?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "The lump sum calculator uses the principles of compound growth to estimate the future value of a one-time investment. It considers the investment amount, expected annual return and tenure to project the estimated maturity value."
              }
            },
            {
              "@type": "Question",
              name: "What is the minimum lumpsum investment in mutual funds?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "The minimum investment amount varies across mutual fund schemes and fund houses. Many schemes allow investments starting from ₹100 or ₹500, while others may require higher minimum amounts. Distributors should always verify the investment requirements of the selected scheme before making recommendations."
              }
            },
            {
              "@type": "Question",
              name: "Is a lumpsum investment better than a SIP?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "Both approaches have their place in financial planning. A lumpsum investment may be suitable when clients have a significant amount available for immediate investment, whereas SIPs are generally preferred for disciplined investing through regular contributions. The right choice depends on the client's financial goals, cash flow, investment horizon and risk appetite."
              }
            },
            {
              "@type": "Question",
              name: "Can clients redeem their lumpsum investment anytime?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "Most open-ended mutual fund schemes allow investors to redeem their investments whenever required. However, certain schemes may levy an exit load if redeemed within a specified period, and capital gains taxes may apply depending on the holding period. Distributors should educate clients about these implications before investing."
              }
            }
          ]
        }
      ]
    }
  };

  return {
    props: {
      seoData
    }
  };
}

export default LumpsumPage;
